export default {"src":"/_next/static/media/fast-purchase.d34ebb8f.svg","height":88,"width":210};